import React from "react";
import { MapPin, Phone, EnvelopeSimple, Clock } from "@phosphor-icons/react";
import { LOGO_URL } from "./assets";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0F0F0F] text-[#E4E4E7] relative overflow-hidden">
      <div className="absolute bottom-0 left-0 right-0 watermark text-[260px] md:text-[400px] whitespace-nowrap select-none pointer-events-none leading-none" style={{ color: "rgba(255,255,255,0.04)" }}>
        RAPIDGARÁZS
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-20 md:py-24">
        <div className="grid md:grid-cols-4 gap-10 mb-16">
          <div className="md:col-span-2">
            <a href="#top" className="inline-flex items-center gap-3 mb-5">
              <span className="bg-[#FFFFFF] p-2 rounded-sm">
                <img src={LOGO_URL} alt="Rapidgarázs" className="h-9 w-auto object-contain block" />
              </span>
              <span className="font-display font-black text-2xl tracking-tight text-[#FFFFFF]">Rapidgarázs</span>
            </a>
            <p className="text-[#E4E4E7]/70 max-w-md leading-relaxed">
              Egyedi méretű szendvicspanel garázsok és melléképületek — gyártás, szállítás, kulcsrakész kivitelezés. Magyarország egész területén.
            </p>
          </div>

          <div>
            <h4 className="font-display font-bold text-[#FFFFFF] text-sm uppercase tracking-wider mb-4">Navigáció</h4>
            <ul className="space-y-2 text-sm">
              {[
                { href: "#configurator", label: "Konfigurátor" },
                { href: "#usp", label: "Előnyök" },
                { href: "#references", label: "Referenciák" },
                { href: "#quote", label: "Ajánlatkérés" },
                { href: "#chatbot", label: "AI Chatbot" },
              ].map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="hover:text-[#FFFFFF] transition-colors">{l.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-bold text-[#FFFFFF] text-sm uppercase tracking-wider mb-4">Elérhetőség</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <Phone size={16} className="mt-0.5 shrink-0" />
                <div>
                  <a href="tel:+36204471719" className="text-[#FFFFFF] font-semibold hover:text-[#FFFFFF]">+36 20 447 1719</a>
                  <div className="text-xs text-[#E4E4E7]/60">H–P: 8–18, Szo: 9–13</div>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <EnvelopeSimple size={16} className="mt-0.5 shrink-0" />
                <a href="mailto:rapidgarazs@gmail.com" className="hover:text-[#FFFFFF]">rapidgarazs@gmail.com</a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={16} className="mt-0.5 shrink-0" />
                <div>
                  <div>Saját üzem</div>
                  <div className="text-xs text-[#E4E4E7]/60">Hamarosan érkezik</div>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <Clock size={16} className="mt-0.5 shrink-0" />
                <div>Ajánlat: 24 munkaóra</div>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-[#E4E4E7]/15 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-[#E4E4E7]/60">
          <div>© {new Date().getFullYear()} Rapidgarázs — Minden jog fenntartva</div>
          <div className="flex gap-6">
            <a href="#" className="hover:text-[#FFFFFF]">Adatkezelés</a>
            <a href="#" className="hover:text-[#FFFFFF]">ÁSZF</a>
            <a href="#" className="hover:text-[#FFFFFF]">Cookie-k</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
